import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { authApi } from 'features/auth/services';
import { userApi } from 'features/user/services';
import { subscriptionsApi } from 'features/subscriptions/services';
import { communitiesAPi } from 'features/communities/services';
import { adminReducers } from 'features/admin/store';

import { monetizationReducers } from '../features/monetization/services';
import { selectionReducer } from '../features/common/store/selectionSlice';
import { chatsApi } from '../features/communities/components/Chats/service/chat.api';
import { analyticsReducers } from '../features/analytics/store';
import { recommendationsAIApi } from '../features/communities/components/recommendations/service/recommendations-ai.api';
import { recommendationAIReducer } from '../features/communities/components/recommendations/store/recommendationAISlice';
import { crmReducers } from '../features/crm/store';
import { shopReducers } from '../features/shops/store';
import { coursesReducers } from '../features/courses/store';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['shop'],
};

const rootReducer = combineReducers({
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
    [communitiesAPi.reducerPath]: communitiesAPi.reducer,
    [chatsApi.reducerPath]: chatsApi.reducer,
    ...adminReducers,
    ...monetizationReducers,
    ...shopReducers,
    ...analyticsReducers,
    ...crmReducers,
    ...coursesReducers,
    selection: selectionReducer,

    [recommendationsAIApi.reducerPath]: recommendationsAIApi.reducer,
    recommendationAISelector: recommendationAIReducer,
});

export default persistReducer(persistConfig, rootReducer);
